import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_protected/home/accounts/deposits/$accountId',
)({
  staticData: {crumbKey: 'navigation.deposit-account'},
});
